import React from "react";
import ReactDOM from "react-dom/client";
import "@/lib/fetch-shield"; // Install BEFORE any React / app code runs.
import "@/index.css";
import App from "@/App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

/* ─── Service worker registration (PWA) ─────────────────────────────
 * Registers after the page has loaded so SW install never competes
 * with the initial render. Only enabled in production (CRA dev
 * server hot-reload conflicts with SW).  Survives soft-navigations
 * because the SW scope is the site root.
 */
if (typeof window !== "undefined"
    && "serviceWorker" in navigator
    && window.location.protocol === "https:") {
  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/service-worker.js", { scope: "/" })
      .then((reg) => {
        // Trigger an update check whenever the user comes back to the tab.
        document.addEventListener("visibilitychange", () => {
          if (document.visibilityState === "visible") {
            reg.update().catch(() => {});
          }
        });
      })
      .catch(() => { /* SW unsupported / blocked — silently degrade. */ });
  });
}
